import MileageListRequest, {
  MileageListRequestState,
  MileageListRequestVehicleType,
  MileageResultsOrder,
} from "../../../api/raily/mileage/list/mileage-list.request";
import MileageStatus from "../../../types/mileage-status";
import VehicleType from "../../../types/vehicle-type";
import paginationService from "../../../utils/pagination/pagination.service";
import MileageListParams, {
  MileageListParamsOrder,
} from "./mileage-list-params";

const createOrder = (
  order?: MileageListParamsOrder | undefined,
): MileageResultsOrder | undefined => {
  switch (order) {
    case MileageListParamsOrder.CARD_NO_ASC:
      return MileageResultsOrder.CARD_NO_ASC;
    case MileageListParamsOrder.CARD_NO_DESC:
      return MileageResultsOrder.CARD_NO_DESC;
    case MileageListParamsOrder.DATE_ASC:
      return MileageResultsOrder.DATE_ASC;
    case MileageListParamsOrder.DATE_DESC:
      return MileageResultsOrder.DATE_DESC;
    case MileageListParamsOrder.DISTANCE_ASC:
      return MileageResultsOrder.DISTANCE_ASC;
    case MileageListParamsOrder.DISTANCE_DESC:
      return MileageResultsOrder.DISTANCE_DESC;
    case MileageListParamsOrder.HUMAN_ID_ASC:
      return MileageResultsOrder.HUMAN_ID_ASC;
    case MileageListParamsOrder.HUMAN_ID_DESC:
      return MileageResultsOrder.HUMAN_ID_DESC;
    case MileageListParamsOrder.WORKER_NAME_ASC:
      return MileageResultsOrder.WORKER_NAME_ASC;
    case MileageListParamsOrder.WORKER_NAME_DESC:
      return MileageResultsOrder.WORKER_NAME_DESC;
    case MileageListParamsOrder.CARGO_COMPANY_NAME_ASC:
      return MileageResultsOrder.CARGO_COMPANY_NAME_ASC;
    case MileageListParamsOrder.CARGO_COMPANY_NAME_DESC:
      return MileageResultsOrder.CARGO_COMPANY_NAME_DESC;
    case MileageListParamsOrder.WORKER_LAST_NAME_ASC:
      return MileageResultsOrder.WORKER_LAST_NAME_ASC;
    case MileageListParamsOrder.WORKER_LAST_NAME_DESC:
      return MileageResultsOrder.WORKER_LAST_NAME_DESC;
    default:
      return undefined;
  }
};

const createVehicleType = (
  type: VehicleType | undefined,
): MileageListRequestVehicleType | undefined => {
  switch (type) {
    case VehicleType.CAR_GT_900CM3:
      return MileageListRequestVehicleType.CAR_GT_900CM3;
    case VehicleType.CAR_LE_900CM3:
      return MileageListRequestVehicleType.CAR_LE_900CM3;
    case VehicleType.COMPANY_OWNED:
      return MileageListRequestVehicleType.COMPANY_OWNED;
    case VehicleType.MOPED:
      return MileageListRequestVehicleType.MOPED;
    case VehicleType.MOTORCYCLE:
      return MileageListRequestVehicleType.MOTORCYCLE;
    default:
      return undefined;
  }
};

const createState = (
  state: MileageStatus | undefined,
): MileageListRequestState | undefined => {
  switch (state) {
    case MileageStatus.ACCEPTED:
      return MileageListRequestState.ACCEPTED;
    case MileageStatus.DELEGATION_CREATED:
      return MileageListRequestState.DELEGATION_CREATED;
    case MileageStatus.PENDING:
      return MileageListRequestState.PENDING;
    case MileageStatus.REJECTED:
      return MileageListRequestState.REJECTED;
  }
};

const create = (params: MileageListParams): MileageListRequest => {
  return {
    address: params.address,
    cardNumber: params.cardNumber,
    companyId: params.companyId,
    dateSince: params.dateSince,
    dateTo: params.dateTo,
    distanceMax: params.distanceMax,
    distanceMin: params.distanceMin,
    endAddress: params.endAddress,
    cargoCompanyName: params.cargoCompanyName,
    humanId: params.humanId,
    limit: params.pageSize,
    midAddress: params.midAddress,
    mileageNumber: params.mileageNumber,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    startAddress: params.startAddress,
    workerName: params.workerName,
    vehicleType: createVehicleType(params.vehicleType),
    state: createState(params.state),
  };
};

const mileageListParamsFactory = {
  create,
};

export default mileageListParamsFactory;
